import { getBitValueFromHex } from './BitValueCalculator';

export const getCombinedMeaning = (bitRange, pageKey, byteIndex, builderData, currentHexValue) => {
  if (pageKey === 'cvmResults' && byteIndex === 1 && bitRange === '6-1') {
    const combinedBits = [];
    for (let bit = 6; bit >= 1; bit--) {
      combinedBits.push(getBitValueFromHex(byteIndex, bit, currentHexValue, pageKey) ? '1' : '0');
    }
    const binaryString = combinedBits.join('');
    
    const methodMap = builderData?.method?.map || [];
    const foundMethod = methodMap.find(item => item.codeBits === binaryString);
    
    return foundMethod 
      ? ` ${foundMethod.label}`
      : ` ${builderData?.method?.defaultLabel || 'Unknown'}`;
  }
  
  if (pageKey === 'tvr' && byteIndex === 5 && bitRange === '2-1') {
    const bit2 = getBitValueFromHex(byteIndex, 2, currentHexValue, pageKey) ? '1' : '0';
    const bit1 = getBitValueFromHex(byteIndex, 1, currentHexValue, pageKey) ? '1' : '0';
    const combinedKey = bit2 + bit1;
    
    const combinedMap = builderData?.byte5CombinedMap || [];
    const foundMapping = combinedMap.find(item => item.key === combinedKey);
    
    return foundMapping 
      ? `${combinedKey} = ${foundMapping.label}`
      : `${combinedKey} = ${builderData?.defaultLabel || 'Unrecognized'}`;
  }
  
  return '';
}

export const getCvmConditionMeaning = (currentHexValue, builderData) => {
  const hexValue = currentHexValue.padStart(6, '0'); 
  const byte2Value = parseInt(hexValue.substring(2, 4), 16); 
  const conditionKey = byte2Value.toString(16).padStart(2, '0').toUpperCase();
  
  const conditions = builderData?.conditions || [];
  const foundCondition = conditions.find(item => item.key === conditionKey);
  
  return foundCondition 
    ? `${conditionKey} = ${foundCondition.label}`
    : `${conditionKey} = Reserved for use by individual payment systems`;
}

export const getCvmResultMeaning = (currentHexValue, builderData) => {
  const hexValue = currentHexValue.padStart(6, '0'); 
  const byte3Value = parseInt(hexValue.substring(4, 6), 16);
  const resultKey = byte3Value.toString(16).padStart(2, '0').toUpperCase();
  
  const resultMap = builderData?.resultMap || [];
  const foundResult = resultMap.find(item => item.key === resultKey);
  
  if (foundResult) {
    return `${resultKey} = ${foundResult.label}`;
  } 
  return `${resultKey} = Unrecognized`;
}
